import _, { add } from 'lodash'
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrent as selectUserCurrent } from '../../../../../redux/user/selectors';
import { useAppDispatch } from '../../../../../hooks/hooks';
import useWindowDimensions from '../../../../../hooks/useWindowsDimensions';
import { user } from '../../../../../redux/user/actions';
import EditProfileAddress from '../../../../../models/EditProfileAddress';
import ProfileAddress from '../../../../../models/ProfileAddress';

export default function FromAddress({
    addressbookId,
    addressBook,
    selectedFromAddressBookId,
    setSelectedFromAddressBookId,
    selectedFromAddressBook,
    setSelectedFromAddressBook,
    onClose
}: any) {
    const dispatch = useAppDispatch();
    const { viewProfile, editProfile } = useSelector(selectUserCurrent)
    const [isAddNewAddress, setAddNewAddress] = useState<boolean>(false);
    const handleSelectFromAddress = (address: any) => {
        setSelectedFromAddressBookId(address.Id);

        setSelectedFromAddressBook(address);
    };

    const confirmAddress = () => {

        dispatch(user.set({ showBillingAddressForm: 'close' }))
        onClose();
    }

    const back = () => {
        dispatch(user.set({ showBillingAddressForm: 'close' }))
    }

    const addNewAddress = () => {
        setAddNewAddress(true);
        dispatch(user.set({ viewProfile: 'open' }))
    }

    const handleAddress = () => {
        setAddNewAddress(false);

        dispatch(user.set({ editProfile: 'open' }))
    }

    return (

        //  Start - Web View
        <>
            <div className="grid grid-cols-1 bg-white">
                {_.map(addressBook, (address: any) => (
                    <div
                        key={address.Id}
                        className={`relative ps-5 md:ps-7 mb-2 ${selectedFromAddressBookId === address.Id ? 'border-blue-500' : ''}`}
                        onClick={() => handleSelectFromAddress(address)}
                    >
                        <div className={`w-full p-2 bg-white border ${selectedFromAddressBookId === address.Id ? 'border-blue-500' : 'border-gray-200'} rounded-lg`}>
                            <div onClick={() => { handleAddress() }} className="absolute top-0 right-0 mt-2 mr-2 inline-flex items-center px-3 py-2 text-sm  text-center cursor-pointer">
                                <svg xmlns="http:www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z" /></svg>
                            </div>

                            <div className="mb-2 text-sm font-bold tracking-tight text-gray-900 capitalize"><span>{`${address?.FirstName}, ${address?.LastName}`}</span></div>

                            <p className="mb-3 font-normal text-gray-700">
                                {/* <span>{`${address.FirstName}, ${address.LastName}`}</span><br /> */}
                                {`${address?.Address1}, ${address?.Address2}`}
                                {`${address?.City}, ${address?.StateProvince?.Name}`}
                                {`${address?.ZipPostalCode}`}
                            </p>
                        </div>
                    </div>
                ))}

            </div>

            {/* } */}
            <div className='flex flex-col w-full'>
                {editProfile == 'open' ? <EditProfileAddress addressBookId={addressbookId} address={selectedFromAddressBook} /> : <></>}
                {viewProfile == 'open' ? <ProfileAddress /> : <></>}
            </div>
            {editProfile !== 'open' && viewProfile !== 'open' && <div className='flex w-full justify-end'>
                <button
                    onClick={() => addNewAddress()}
                    className="m-4 bg-gray-800 text-white hover:bg-secondary font-semibold px-1 py-1 h-10 w-40 rounded-md"
                >
                    Add address
                </button>
                <button
                    disabled={!selectedFromAddressBook}
                    onClick={() => confirmAddress()}
                    className={`m-4 bg-gray-800 text-white hover:bg-secondary disabled:bg-gray-100 font-semibold px-1 py-1 h-10 w-60 rounded-md`}>
                    Use this address
                </button>
            </div>}
        </>
        //  End - Web View 

    );
}
